module.exports = __webpack_public_path__ + "media/images/inactive-1a4ba4a998d86cedd64b9009ac827b4f.svg";